import { c as _c } from "react/compiler-runtime";
import { LinkExternal01Icon } from '@systemeio/icons';
import EditActionWrapper from 'modules/automation-rules/actions/components/edit-actions/components/edit-action-wrapper';
import { EditActionItemInterface } from 'modules/automation-rules/actions/components/edit-actions/types/edit-action-item-interface';
import { ActionPipelineStageEditInterface } from 'modules/automation-rules/actions/types/automation-rule-actions-edit-interface';
import { getData, getDataFromObj } from 'modules/automation-rules/utils/get-filter-data';
import { usePipelineStageList } from 'modules/crm/pipeline/hooks/use-pipeline-stage-list';
import React from 'react';
import { FormSelect } from 'shared/components';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface ActionAssignPipelineStageItemProps extends EditActionItemInterface<ActionPipelineStageEditInterface> {}
const ActionAssignPipelineStageItem = t0 => {
  const $ = _c(18);
  const {
    actions,
    action,
    onDelete,
    setRules,
    errors,
    idx
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    pipelineStage,
    isLoading
  } = usePipelineStageList(action.pipelineStage.pipeline.id);
  let t1;
  if ($[0] !== idx || $[1] !== onDelete) {
    t1 = () => onDelete(idx);
    $[0] = idx;
    $[1] = onDelete;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== action.id || $[4] !== action.pipelineStage.id || $[5] !== action.pipelineStage.pipeline || $[6] !== actions || $[7] !== errors || $[8] !== idx || $[9] !== isLoading || $[10] !== pipelineStage || $[11] !== setRules || $[12] !== t) {
    t2 = t3 => {
      const {
        data,
        onOpen,
        renderActionLabel
      } = t3;
      return <><FormSelect onOpen={onOpen} required={true} label={renderActionLabel({
          label: t("dashboard.automation_rule.crm.label_pipeline"),
          additionalLabel: action.pipelineStage.id ? <LinkWithoutPrefetch rel="noreferrer" target="_blank" className="group self-center outline-hidden" href="/crm-pipeline"><LinkExternal01Icon className="text-icon-tertiary transition-base group-focus-visible:text-icon-accent hover:text-icon-link-hover" /></LinkWithoutPrefetch> : undefined
        })} placeholder={t("dashboard.automation_rule.crm.select_pipeline")} value={action.pipelineStage.pipeline.id} data={data.pipelineData} staticData={getDataFromObj(action.pipelineStage.pipeline)} onChange={data_0 => setRules(prev => ({
          ...prev,
          actions: actions.map((el, i) => {
            if (idx === i) {
              return {
                ...el,
                pipelineStage: {
                  pipeline: {
                    id: data_0
                  }
                }
              };
            } else {
              return el;
            }
          })
        }))} />{action.pipelineStage.pipeline.id && <FormSelect required={true} label={t("dashboard.automation_rule.crm.label_stage")} placeholder={t("dashboard.automation_rule.crm.select_stage")} data={pipelineStage ? getData(Object.values(pipelineStage?.items)) : undefined} value={action.pipelineStage.id} onChange={data_1 => setRules(prev_0 => ({
          ...prev_0,
          actions: actions.map((el_0, i_0) => {
            if (idx === i_0) {
              return {
                ...el_0,
                pipelineStage: {
                  pipeline: {
                    id: action.pipelineStage.pipeline.id
                  },
                  id: data_1
                }
              };
            } else {
              return el_0;
            }
          })
        }))} error={errors.automationActions[action.id]?.pipelineStage?.join("")} isPreFetching={isLoading} />}</>;
    };
    $[3] = action.id;
    $[4] = action.pipelineStage.id;
    $[5] = action.pipelineStage.pipeline;
    $[6] = actions;
    $[7] = errors;
    $[8] = idx;
    $[9] = isLoading;
    $[10] = pipelineStage;
    $[11] = setRules;
    $[12] = t;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  if ($[14] !== action.type || $[15] !== t1 || $[16] !== t2) {
    t3 = <EditActionWrapper slug={action.type} onDelete={t1}>{t2}</EditActionWrapper>;
    $[14] = action.type;
    $[15] = t1;
    $[16] = t2;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  return t3;
};
export default ActionAssignPipelineStageItem;